import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function localReturnPath(value) {
  return value?.startsWith("/") && !value.startsWith("//") && !value.includes("\\") ? value : "/";
}


export const CATEGORY_COLORS = {
  under_20: "bg-[#2EC4B6]/15 text-[#0F7A72] border-[#2EC4B6]/30",
  "20_40": "bg-[#FF9F1C]/15 text-[#B36906] border-[#FF9F1C]/30",
  "41_60": "bg-[#FFBF69]/25 text-[#8A5A17] border-[#FFBF69]/40",
  "61_90": "bg-[#FDE74C]/40 text-[#7A5F00] border-[#FDE74C]/60",
  "90_120": "bg-sky-100 text-sky-800 border-sky-200",
};

export const STATUS_LABEL = {
  pending: "Pending",
  arrived: "Arrived",
  no_show: "No-show",
  na: "N/A",
};

export const STATUS_COLORS = {
  pending: "bg-slate-100 text-slate-600 border-slate-200",
  arrived: "bg-[#2EC4B6]/15 text-[#0F7A72] border-[#2EC4B6]/40",
  no_show: "bg-[#E71D36]/10 text-[#E71D36] border-[#E71D36]/30",
  na: "bg-[#FDE74C]/40 text-[#7A5F00] border-[#FDE74C]",
};

export const ALL_STATUSES = ["pending", "arrived", "no_show", "na"];


export function isHistoricalResult(record) {
  return record?.official_format === "average_of_5";
}

export function competitionResultLabel(record) {
  return isHistoricalResult(record) ? "Historical average" : "Competition Solve";
}

export function formatSeconds(v) {
  if (v == null || v === "" || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  return n.toFixed(2) + "s";
}
